import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from "./privateRoute";
import models from "../model-declaration";
import Dashbaord from "../modules/dashboard";
import ListPage from "../modules/list";
import ViewPage from "../modules/read";
import Createpage from "../modules/create";
import Editpage from "../modules/edit";
import ProtectedRoute from "./protectedRoute";
import LoginPage from "../modules/auth/login";
import CreateUsers from "../modules/admin/users/create-users";
import ListUsers from "../modules/admin/users/list-users";
import ReadUsers from "../modules/admin/users/read-users";
import EditUsers from "../modules/admin/users/edit-users";
import ListRoles from "../modules/admin/roles/list-roles";
import CreateRoles from "../modules/admin/roles/create-roles";
import ViewRoles from "../modules/admin/roles/view-roles";
import EditRoles from "../modules/admin/roles/edit-roles";
import ListDepartment from "../modules/department/list-department";
import CreateDepartment from "../modules/department/create-department";
import EditDepartment from "../modules/department/edit-department";
import ViewDepartment from "../modules/department/view-department";
import ListDesignation from "../modules/designation/list-designation";
import CreateDesignation from "../modules/designation/create-designation";
import EditDesignation from "../modules/designation/edit-designation";
import ViewDesignation from "../modules/designation/view-designation";
import ListState from "../modules/state/list-state";
import CreateState from "../modules/state/create-state";
import EditState from "../modules/state/edit-state";
import ViewState from "../modules/state/view-state";
import ListCity from "../modules/city/list-city";
import CreateCity from "../modules/city/create-city";
import EditCity from "../modules/city/edit-city";
import ViewCity from "../modules/city/view-city";
import ListCompany from "../modules/company/list-company";
import CreateCompany from "../modules/company/create-company";
import EditCompany from "../modules/company/edit-company";
import ViewCompany from "../modules/company/view-company";
import ListMarketingMaterialsCategory from "../modules/marketing-materials-category/list-marketing-materials-category";
import CreateMarketingMaterialsCategory from "../modules/marketing-materials-category/create-marketing-materials-category";
import EditMarketingMaterialsCategory from "../modules/marketing-materials-category/edit-marketing-materials-category";
import ViewMarketingMaterialsCategory from "../modules/marketing-materials-category/view-marketing-materials-category";
import ListProduct from "../modules/product/list-product";
import CreateProduct from "../modules/product/create-product";
import EditProduct from "../modules/product/edit-product";
import ViewProduct from "../modules/product/view-product";
import ListMarketingMaterials from "../modules/marketing-materials/list-marketing-materials";
import CreateMarketingMaterials from "../modules/marketing-materials/create-marketing-materials";
import EditMarketingMaterials from "../modules/marketing-materials/edit-marketing-materials";
import ViewMarketingMaterials from "../modules/marketing-materials/view-marketing-materials";
import ListLead from "../modules/lead/list-lead";
import CreateLead from "../modules/lead/create-lead";
import EditLead from "../modules/lead/edit-lead";
import ViewLead from "../modules/lead/view-lead";
import ListCustomer from "../modules/customer/list-customer";
import CreateCustomer from "../modules/customer/create-customer";
import EditCustomer from "../modules/customer/edit-customer";
import ViewCustomer from "../modules/customer/view-customer";
import LeadsActivityAllList from "../modules/lead-activity/leads-activity-list";
import CustomerActivityAllList from "../modules/customer-activity/customer-activity-list";
import Unauthorized from "../utils/unaouthorized";
import { RoleRoute } from "./route-permission-list";
import { useRole } from "../context/role/RoleContext";
import ListOrders from "../modules/orders/list-orders";
import CreateOrders from "../modules/orders/create-orders";
import ListPayment from "../modules/payment/list-payment";
import CreatePayment from "../modules/payment/create-payment";
import EditPayment from "../modules/payment/edit-payment";
import ViewPayment from "../modules/payment/view-payment";
import ListEmployeeRequest from "../modules/employee-request/list-employee-request";
import CreateEmployeeRequest from "../modules/employee-request/create-employee-request";
import EditEmployeeRequest from "../modules/employee-request/edit-employee-request";
import ViewEmployeeRequest from "../modules/employee-request/view-employee-request";
import ViewOrders from "../modules/orders/view-orders";
import EditOrders from "../modules/orders/edit-orders";
import ListTileLayer from "../modules/tile-layer/list-tile-layer";
import CreateTileLayer from "../modules/tile-layer/create-tile-layer";
import EditTileLayer from "../modules/tile-layer/edit-tile-layer";
import ViewTileLayer from "../modules/tile-layer/view-tile-layer";
import ListExpense from "../modules/expense/list-expense";
import CreateExpense from "../modules/expense/create-expense";
import EditExpense from "../modules/expense/edit-expense";
import ViewExpense from "../modules/expense/view-expense";

const MainRoutes = () => {
  const { state } = useRole();
  return (
    <Router>
      <Routes>
        <Route path="/unauthorized" element={<Unauthorized />} />

        <Route element={<PrivateRoute />}>
          <Route path="/dashboard" element={<Dashbaord />} />

          {/* ------ ADMIN USERS ------ */}
          <Route
            path="/admin/users/list"
            element={
              <RoleRoute
                resourceName={"employee"}
                resourceAction={
                  state?.role?.employee?.write
                    ? "write"
                    : state?.role?.employee?.read
                    ? "read"
                    : ""
                }
              >
                <ListUsers />
              </RoleRoute>
            }
          />
          <Route
            path="/admin/users/create"
            element={
              <RoleRoute
                resourceName={"employee"}
                resourceAction={state?.role?.employee?.write ? "write" : ""}
              >
                <CreateUsers />
              </RoleRoute>
            }
          />
          <Route
            path="/admin/users/view/:id"
            element={
              <RoleRoute
                resourceName={"employee"}
                resourceAction={
                  state?.role?.employee?.write
                    ? "write"
                    : state?.role?.employee?.read
                    ? "read"
                    : ""
                }
              >
                <ReadUsers />
              </RoleRoute>
            }
          />
          <Route
            path="/admin/users/edit/:id"
            element={
              <RoleRoute
                resourceName={"employee"}
                resourceAction={state?.role?.employee?.write ? "write" : ""}
              >
                <EditUsers />
              </RoleRoute>
            }
          />

          {/* ------ ADMIN ROLES ------ */}
          <Route
            path="/admin/roles/list"
            element={
              <RoleRoute
                resourceName={"employee"}
                resourceAction={
                  state?.role?.employee?.write
                    ? "write"
                    : state?.role?.employee?.read
                    ? "read"
                    : ""
                }
              >
                <ListRoles />
              </RoleRoute>
            }
          />
          <Route
            path="/admin/roles/create"
            element={
              <RoleRoute
                resourceName={"employee"}
                resourceAction={state?.role?.employee?.write ? "write" : ""}
              >
                <CreateRoles />
              </RoleRoute>
            }
          />
          <Route
            path="/admin/roles/view/:id"
            element={
              <RoleRoute
                resourceName={"employee"}
                resourceAction={
                  state?.role?.employee?.write
                    ? "write"
                    : state?.role?.employee?.read
                    ? "read"
                    : ""
                }
              >
                <ViewRoles />
              </RoleRoute>
            }
          />
          <Route
            path="/admin/roles/edit/:id"
            element={
              <RoleRoute
                resourceName={"employee"}
                resourceAction={state?.role?.employee?.write ? "write" : ""}
              >
                <EditRoles />
              </RoleRoute>
            }
          />

          {/* ------ LEAD ------ */}
          <Route
            path="/lead/list"
            element={
              <RoleRoute
                resourceName={"lead"}
                resourceAction={
                  state?.role?.lead?.write
                    ? "write"
                    : state?.role?.lead?.read
                    ? "read"
                    : ""
                }
              >
                <ListLead />
              </RoleRoute>
            }
          />
          <Route
            path="/lead/create"
            element={
              <RoleRoute
                resourceName={"lead"}
                resourceAction={state?.role?.lead?.write ? "write" : ""}
              >
                <CreateLead />
              </RoleRoute>
            }
          />
          <Route
            path="/lead/edit/:id"
            element={
              <RoleRoute
                resourceName={"lead"}
                resourceAction={state?.role?.lead?.write ? "write" : ""}
              >
                <EditLead />
              </RoleRoute>
            }
          />
          <Route
            path="/lead/view/:id"
            element={
              <RoleRoute
                resourceName={"lead"}
                resourceAction={
                  state?.role?.lead?.write
                    ? "write"
                    : state?.role?.lead?.read
                    ? "read"
                    : ""
                }
              >
                <ViewLead />
              </RoleRoute>
            }
          />

          {/* ------ LEAD ACTIVITY ------ */}
          <Route
            path="/lead-activity/list"
            element={
              <RoleRoute
                resourceName={"lead_activity"}
                resourceAction={
                  state?.role?.lead_activity?.write
                    ? "write"
                    : state?.role?.lead_activity?.read
                    ? "read"
                    : ""
                }
              >
                <LeadsActivityAllList />
              </RoleRoute>
            }
          />

          {/* ------ CUSTOMER ------ */}
          <Route
            path="/customer/list"
            element={
              <RoleRoute
                resourceName={"customer"}
                resourceAction={
                  state?.role?.customer?.write
                    ? "write"
                    : state?.role?.customer?.read
                    ? "read"
                    : ""
                }
              >
                <ListCustomer />
              </RoleRoute>
            }
          />
          <Route
            path="/customer/create"
            element={
              <RoleRoute
                resourceName={"customer"}
                resourceAction={state?.role?.customer?.write ? "write" : ""}
              >
                <CreateCustomer />
              </RoleRoute>
            }
          />
          <Route
            path="/customer/edit/:id"
            element={
              <RoleRoute
                resourceName={"customer"}
                resourceAction={state?.role?.customer?.write ? "write" : ""}
              >
                <EditCustomer />
              </RoleRoute>
            }
          />
          <Route
            path="/customer/view/:id"
            element={
              <RoleRoute
                resourceName={"customer"}
                resourceAction={
                  state?.role?.customer?.write
                    ? "write"
                    : state?.role?.customer?.read
                    ? "read"
                    : ""
                }
              >
                <ViewCustomer />
              </RoleRoute>
            }
          />

          {/* ------ CUSTOMER ACTIVITY ------ */}
          <Route
            path="/customer-activity/list"
            element={<CustomerActivityAllList />}
          />

          {/* ------ STATE ------ */}
          <Route
            path="/state/list"
            element={
              <RoleRoute
                resourceName={"settings"}
                resourceAction={
                  state?.role?.settings?.write
                    ? "write"
                    : state?.role?.settings?.read
                    ? "read"
                    : ""
                }
              >
                <ListState />
              </RoleRoute>
            }
          />
          <Route
            path="/state/create"
            element={
              <RoleRoute
                resourceName={"settings"}
                resourceAction={state?.role?.settings?.write ? "write" : ""}
              >
                <CreateState />
              </RoleRoute>
            }
          />
          <Route
            path="/state/edit/:id"
            element={
              <RoleRoute
                resourceName={"settings"}
                resourceAction={state?.role?.settings?.write ? "write" : ""}
              >
                <EditState />
              </RoleRoute>
            }
          />
          <Route
            path="/state/view/:id"
            element={
              <RoleRoute
                resourceName={"settings"}
                resourceAction={
                  state?.role?.settings?.write
                    ? "write"
                    : state?.role?.settings?.read
                    ? "read"
                    : ""
                }
              >
                <ViewState />
              </RoleRoute>
            }
          />

          {/* ------ CITY ------ */}
          <Route
            path="/city/list"
            element={
              <RoleRoute
                resourceName={"settings"}
                resourceAction={
                  state?.role?.settings?.write
                    ? "write"
                    : state?.role?.settings?.read
                    ? "read"
                    : ""
                }
              >
                <ListCity />
              </RoleRoute>
            }
          />
          <Route
            path="/city/create"
            element={
              <RoleRoute
                resourceName={"settings"}
                resourceAction={state?.role?.settings?.write ? "write" : ""}
              >
                <CreateCity />
              </RoleRoute>
            }
          />
          <Route
            path="/city/edit/:id"
            element={
              <RoleRoute
                resourceName={"settings"}
                resourceAction={state?.role?.settings?.write ? "write" : ""}
              >
                <EditCity />
              </RoleRoute>
            }
          />
          <Route
            path="/city/view/:id"
            element={
              <RoleRoute
                resourceName={"settings"}
                resourceAction={
                  state?.role?.settings?.write
                    ? "write"
                    : state?.role?.settings?.read
                    ? "read"
                    : ""
                }
              >
                <ViewCity />
              </RoleRoute>
            }
          />

          {/* ------ DEPARTMENT ------ */}
          <Route
            path="/department/list"
            element={
              <RoleRoute
                resourceName={"settings"}
                resourceAction={
                  state?.role?.settings?.write
                    ? "write"
                    : state?.role?.settings?.read
                    ? "read"
                    : ""
                }
              >
                <ListDepartment />
              </RoleRoute>
            }
          />
          <Route
            path="/department/create"
            element={
              <RoleRoute
                resourceName={"settings"}
                resourceAction={state?.role?.settings?.write ? "write" : ""}
              >
                <CreateDepartment />
              </RoleRoute>
            }
          />
          <Route
            path="/department/edit/:id"
            element={
              <RoleRoute
                resourceName={"settings"}
                resourceAction={state?.role?.settings?.write ? "write" : ""}
              >
                <EditDepartment />
              </RoleRoute>
            }
          />
          <Route
            path="/department/view/:id"
            element={
              <RoleRoute
                resourceName={"settings"}
                resourceAction={
                  state?.role?.settings?.write
                    ? "write"
                    : state?.role?.settings?.read
                    ? "read"
                    : ""
                }
              >
                <ViewDepartment />
              </RoleRoute>
            }
          />

          {/* ------ DESIGNATION ------ */}
          <Route
            path="/designation/list"
            element={
              <RoleRoute
                resourceName={"settings"}
                resourceAction={
                  state?.role?.settings?.write
                    ? "write"
                    : state?.role?.settings?.read
                    ? "read"
                    : ""
                }
              >
                <ListDesignation />
              </RoleRoute>
            }
          />
          <Route
            path="/designation/create"
            element={
              <RoleRoute
                resourceName={"settings"}
                resourceAction={state?.role?.settings?.write ? "write" : ""}
              >
                <CreateDesignation />
              </RoleRoute>
            }
          />
          <Route
            path="/designation/edit/:id"
            element={
              <RoleRoute
                resourceName={"settings"}
                resourceAction={state?.role?.settings?.write ? "write" : ""}
              >
                <EditDesignation />
              </RoleRoute>
            }
          />
          <Route
            path="/designation/view/:id"
            element={
              <RoleRoute
                resourceName={"settings"}
                resourceAction={
                  state?.role?.settings?.write
                    ? "write"
                    : state?.role?.settings?.read
                    ? "read"
                    : ""
                }
              >
                <ViewDesignation />
              </RoleRoute>
            }
          />

          {/* ------ COMPANY ------ */}
          <Route
            path="/company/list"
            element={
              <RoleRoute
                resourceName={"company"}
                resourceAction={
                  state?.role?.company?.write
                    ? "write"
                    : state?.role?.company?.read
                    ? "read"
                    : ""
                }
              >
                <ListCompany />
              </RoleRoute>
            }
          />
          <Route
            path="/company/create"
            element={
              <RoleRoute
                resourceName={"company"}
                resourceAction={state?.role?.company?.write ? "write" : ""}
              >
                <CreateCompany />
              </RoleRoute>
            }
          />
          <Route
            path="/company/edit/:id"
            element={
              <RoleRoute
                resourceName={"company"}
                resourceAction={state?.role?.company?.write ? "write" : ""}
              >
                <EditCompany />
              </RoleRoute>
            }
          />
          <Route
            path="/company/view/:id"
            element={
              <RoleRoute
                resourceName={"company"}
                resourceAction={
                  state?.role?.company?.write
                    ? "write"
                    : state?.role?.company?.read
                    ? "read"
                    : ""
                }
              >
                <ViewCompany />
              </RoleRoute>
            }
          />

          {/* ------ MARKETING MATERIALS CATEGORY ------ */}
          <Route
            path="/marketing-materials-category/list"
            element={
              <RoleRoute
                resourceName={"marketing_material"}
                resourceAction={
                  state?.role?.marketing_material?.write
                    ? "write"
                    : state?.role?.marketing_material?.read
                    ? "read"
                    : ""
                }
              >
                <ListMarketingMaterialsCategory />
              </RoleRoute>
            }
          />
          <Route
            path="/marketing-materials-category/create"
            element={
              <RoleRoute
                resourceName={"marketing_material"}
                resourceAction={
                  state?.role?.marketing_material?.write ? "write" : ""
                }
              >
                <CreateMarketingMaterialsCategory />
              </RoleRoute>
            }
          />
          <Route
            path="/marketing-materials-category/edit/:id"
            element={
              <RoleRoute
                resourceName={"marketing_material"}
                resourceAction={
                  state?.role?.marketing_material?.write ? "write" : ""
                }
              >
                <EditMarketingMaterialsCategory />
              </RoleRoute>
            }
          />
          <Route
            path="/marketing-materials-category/view/:id"
            element={
              <RoleRoute
                resourceName={"marketing_material"}
                resourceAction={
                  state?.role?.marketing_material?.write
                    ? "write"
                    : state?.role?.marketing_material?.read
                    ? "read"
                    : ""
                }
              >
                <ViewMarketingMaterialsCategory />
              </RoleRoute>
            }
          />

          {/* ------ MARKETING MATERIALS ------ */}
          <Route
            path="/marketing-materials/list"
            element={
              <RoleRoute
                resourceName={"marketing_material"}
                resourceAction={
                  state?.role?.marketing_material?.write
                    ? "write"
                    : state?.role?.marketing_material?.read
                    ? "read"
                    : ""
                }
              >
                <ListMarketingMaterials />
              </RoleRoute>
            }
          />

          <Route
            path="/marketing-materials/create"
            element={
              <RoleRoute
                resourceName={"marketing_material"}
                resourceAction={
                  state?.role?.marketing_material?.write ? "write" : ""
                }
              >
                <CreateMarketingMaterials />
              </RoleRoute>
            }
          />
          <Route
            path="/marketing-materials/edit/:id"
            element={
              <RoleRoute
                resourceName={"marketing_material"}
                resourceAction={
                  state?.role?.marketing_material?.write ? "write" : ""
                }
              >
                <EditMarketingMaterials />
              </RoleRoute>
            }
          />
          <Route
            path="/marketing-materials/view/:id"
            element={
              <RoleRoute
                resourceName={"marketing_material"}
                resourceAction={
                  state?.role?.marketing_material?.write
                    ? "write"
                    : state?.role?.marketing_material?.read
                    ? "read"
                    : ""
                }
              >
                <ViewMarketingMaterials />
              </RoleRoute>
            }
          />

          {/* ------ PRODUCT ------ */}
          <Route
            path="/product/list"
            element={
              <RoleRoute
                resourceName={"product"}
                resourceAction={
                  state?.role?.product?.write
                    ? "write"
                    : state?.role?.product?.read
                    ? "read"
                    : ""
                }
              >
                <ListProduct />
              </RoleRoute>
            }
          />
          <Route
            path="/product/create"
            element={
              <RoleRoute
                resourceName={"product"}
                resourceAction={state?.role?.product?.write ? "write" : ""}
              >
                <CreateProduct />
              </RoleRoute>
            }
          />
          <Route
            path="/product/edit/:id"
            element={
              <RoleRoute
                resourceName={"product"}
                resourceAction={state?.role?.product?.write ? "write" : ""}
              >
                <EditProduct />
              </RoleRoute>
            }
          />
          <Route
            path="/product/view/:id"
            element={
              <RoleRoute
                resourceName={"product"}
                resourceAction={
                  state?.role?.product?.write
                    ? "write"
                    : state?.role?.product?.read
                    ? "read"
                    : ""
                }
              >
                <ViewProduct />
              </RoleRoute>
            }
          />

          {/* ------ ORDERS ------ */}
          <Route
            path="/orders/list"
            element={
              <RoleRoute
                resourceName={"order"}
                resourceAction={
                  state?.role?.order?.write
                    ? "write"
                    : state?.role?.order?.read
                    ? "read"
                    : ""
                }
              >
                <ListOrders />
              </RoleRoute>
            }
          />

          <Route
            path="/orders/create"
            element={
              <RoleRoute
                resourceName={"order"}
                resourceAction={state?.role?.order?.write ? "write" : ""}
              >
                <CreateOrders />
              </RoleRoute>
            }
          />

          <Route
            path="/orders/edit/:id"
            element={
              <RoleRoute
                resourceName={"order"}
                resourceAction={state?.role?.order?.write ? "write" : ""}
              >
                <EditOrders />
              </RoleRoute>
            }
          />

          <Route
            path="/orders/view/:id"
            element={
              <RoleRoute
                resourceName={"order"}
                resourceAction={
                  state?.role?.order?.write
                    ? "write"
                    : state?.role?.order?.read
                    ? "read"
                    : ""
                }
              >
                <ViewOrders />
              </RoleRoute>
            }
          />

          {/* ------ PAYMENT ------ */}
          <Route
            path="/payment/list"
            element={
              <RoleRoute
                resourceName={"payment"}
                resourceAction={
                  state?.role?.payment?.write
                    ? "write"
                    : state?.role?.payment?.read
                    ? "read"
                    : ""
                }
              >
                <ListPayment />
              </RoleRoute>
            }
          />

          <Route
            path="/payment/create"
            element={
              <RoleRoute
                resourceName={"payment"}
                resourceAction={state?.role?.payment?.write ? "write" : ""}
              >
                <CreatePayment />
              </RoleRoute>
            }
          />

          <Route
            path="/payment/edit/:id"
            element={
              <RoleRoute
                resourceName={"payment"}
                resourceAction={state?.role?.payment?.write ? "write" : ""}
              >
                <EditPayment />
              </RoleRoute>
            }
          />
          <Route
            path="/payment/view/:id"
            element={
              <RoleRoute
                resourceName={"payment"}
                resourceAction={
                  state?.role?.payment?.write
                    ? "write"
                    : state?.role?.payment?.read
                    ? "read"
                    : ""
                }
              >
                <ViewPayment />
              </RoleRoute>
            }
          />

          {/* ------ Employee Request ------ */}

          <Route
            path="/employee-request/list"
            element={
              <RoleRoute
                resourceName={"employee_request"}
                resourceAction={
                  state?.role?.employee_request?.write
                    ? "write"
                    : state?.role?.employee_request?.read
                    ? "read"
                    : ""
                }
              >
                <ListEmployeeRequest />
              </RoleRoute>
            }
          />

          <Route
            path="/employee-request/create"
            element={
              <RoleRoute
                resourceName={"employee_request"}
                resourceAction={
                  state?.role?.employee_request?.write ? "write" : ""
                }
              >
                <CreateEmployeeRequest />
              </RoleRoute>
            }
          />
          <Route
            path="/employee-request/edit/:id"
            element={
              <RoleRoute
                resourceName={"employee_request"}
                resourceAction={
                  state?.role?.employee_request?.write ? "write" : ""
                }
              >
                <EditEmployeeRequest />
              </RoleRoute>
            }
          />

          <Route
            path="/employee-request/view/:id"
            element={
              <RoleRoute
                resourceName={"employee_request"}
                resourceAction={
                  state?.role?.employee_request?.write
                    ? "write"
                    : state?.role?.employee_request?.read
                    ? "read"
                    : ""
                }
              >
                <ViewEmployeeRequest />
              </RoleRoute>
            }
          />

          {/* ------ TILE LAYER ------ */}
          <Route
            path="/tile-layers/list"
            element={
              <RoleRoute
                resourceName={"tile_layer"}
                resourceAction={
                  state?.role?.tile_layer?.write
                    ? "write"
                    : state?.role?.tile_layer?.read
                    ? "read"
                    : ""
                }
              >
                <ListTileLayer />
              </RoleRoute>
            }
          />
          <Route
            path="/tile-layers/create"
            element={
              <RoleRoute
                resourceName={"tile_layer"}
                resourceAction={state?.role?.tile_layer?.write ? "write" : ""}
              >
                <CreateTileLayer />
              </RoleRoute>
            }
          />
          <Route
            path="/tile-layers/edit/:id"
            element={
              <RoleRoute
                resourceName={"tile_layer"}
                resourceAction={state?.role?.tile_layer?.write ? "write" : ""}
              >
                <EditTileLayer />
              </RoleRoute>
            }
          />
          <Route
            path="/tile-layers/view/:id"
            element={
              <RoleRoute
                resourceName={"tile_layer"}
                resourceAction={
                  state?.role?.tile_layer?.write
                    ? "write"
                    : state?.role?.tile_layer?.read
                    ? "read"
                    : ""
                }
              >
                <ViewTileLayer />
              </RoleRoute>
            }
          />

          <Route
            path="/expense/list"
            element={
              <RoleRoute
                resourceName={"expense"}
                resourceAction={
                  state?.role?.expense?.write
                    ? "write"
                    : state?.role?.expense?.read
                    ? "read"
                    : ""
                }
              >
                <ListExpense />
              </RoleRoute>
            }
          />
          <Route
            path="/expense/create"
            element={
              <RoleRoute
                resourceName={"expense"}
                resourceAction={state?.role?.expense?.write ? "write" : ""}
              >
                <CreateExpense />
              </RoleRoute>
            }
          />
          <Route
            path="/expense/edit/:id"
            element={
              <RoleRoute
                resourceName={"expense"}
                resourceAction={state?.role?.expense?.write ? "write" : ""}
              >
                <EditExpense />
              </RoleRoute>
            }
          />
          <Route
            path="/expense/view/:id"
            element={
              <RoleRoute
                resourceName={"expense"}
                resourceAction={
                  state?.role?.expense?.write
                    ? "write"
                    : state?.role?.expense?.read
                    ? "read"
                    : ""
                }
              >
                <ViewExpense />
              </RoleRoute>
            }
          />

          {models?.map((model) => (
            <React.Fragment>
              <Route
                path={`/${model.tableName}/list`}
                element={<ListPage model={model} />}
              />
              <Route
                path={`/${model.tableName}/view/:id`}
                element={<ViewPage model={model} />}
              />
              <Route
                path={`${model.tableName}/create`}
                element={<Createpage model={model} />}
              />
              <Route
                path={`${model.tableName}/edit/:id`}
                element={<Editpage model={model} />}
              />
            </React.Fragment>
          ))}
        </Route>
        <Route element={<ProtectedRoute />}>
          <Route path={`/`} element={<LoginPage />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default MainRoutes;
